/*
 * 2051565 GTY
 * 创建于2024年1月5日 江西省上饶市玉山县
 */

export function later(callable: any) {
    setTimeout(callable(), 0)
}
